//export default class Criteria {
//   constructor() {
//     this.$sections = document.querySelectorAll('section.criteria');
//   }
//}
//
//new Criteria();
